module.exports = __webpack_public_path__ + "media/images/promo/overlay-vignette-54a699c674245e602a5ed182d41bb1461ef014b5c14534e739edcfb048b615f3.png";